export class GuaranteeType {

  public CartaFianca = 1;
  public Hipoteca = 2;
  public AlineacaoBensMoveis = 3;
  public AlineacaoBensImoveis = 4;
  public Penhor = 5;
  public CessaoCredito = 6;
  public CPR = 7;
  public Outros = 8;

  getArray() {
    return [
        this.CartaFianca,
        this.Hipoteca,
        this.AlineacaoBensMoveis,
        this.AlineacaoBensImoveis,
        this.Penhor,
        this.CessaoCredito,
        this.CPR,
        this.Outros
    ];
  }

  getDescricao(type: number) {
    switch(type) {
      case 1: return "Carta Fiança";
      case 2: return "Hipoteca";
      case 3: return "Alienação de Bens Móveis";
      case 4: return "Alienação de Bens Imóveis";
      case 5: return "Penhor";
      case 6: return "Cessão de Crédito";
      case 7: return "CPR";
      case 8: return "Outros";
      default: return "N/D";
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/models/guarantee-type.ts